import { lazy, Suspense, useEffect } from "react";

/// Components
import { connect, useDispatch } from "react-redux";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams
} from "react-router-dom";
import Index from "./jsx";
// action
import { checkAutoLogin, checkAutoLoginAffiliate } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
/// Style
import "./css/style.css";
import ChangePassword from "./jsx/pages/ChangePassword";
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";

const SignUp = lazy(() => import("./jsx/pages/Registration"));
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const SignUpAfiliado = lazy(() => import("./jsx/pages/nuevoAfiliado"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 500);
  });
});

const AffiliateLogin = lazy(() => import("./jsx/pages/afiliado/login"));

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (!window.location.pathname.includes("/change-password") && !window.location.pathname.includes("/afiliarme")) {
      if (window.location.pathname.includes("afiliado")) {   
        checkAutoLoginAffiliate(dispatch, navigate);
      } else {
        checkAutoLogin(dispatch, navigate);
      }
    }
  }, []);

  let routeblog = (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/afiliado/login" element={<AffiliateLogin />} />
      <Route path="/afiliarme" element={<SignUpAfiliado />} />
      <Route path="/page-register" element={<SignUp />} />
      <Route path="/restore-password" element={<ForgotPassword />} />
      <Route path="/change-password" element={<ChangePassword />} />
    </Routes>
  );

  if (props.isAuthenticated) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {routeblog}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));
